<img class="ai-illustration" src="assets/images/action-tracker-ai.svg" [alt]="alt()" />
